<template>
  <div id="apt-glossary">
    <div class="page-header">
      <div class="title">부동산 용어사전</div>
      <div class="subtitle">부동산 거래와 투자에 필요한 핵심 용어를 알아보세요</div>
    </div>

    <div class="glossary-controls">
      <div class="search-box">
        <input
          v-model="searchQuery"
          type="text"
          placeholder="용어 검색..."
          class="search-input"
        />
      </div>
      <div class="category-tabs">
        <button
          v-for="cat in categories"
          :key="cat"
          :class="['tab-btn', { active: selectedCategory === cat }]"
          @click="selectedCategory = cat"
        >
          {{ cat }}
        </button>
      </div>
    </div>

    <div class="glossary-count">
      총 <strong>{{ filteredTerms.length }}</strong>개 용어
    </div>

    <div class="glossary-list">
      <div
        v-for="item in filteredTerms"
        :key="item.term"
        class="glossary-card"
      >
        <div class="card-header">
          <span class="card-term">{{ item.term }}</span>
          <span class="card-category">{{ item.category }}</span>
        </div>
        <div class="card-desc">{{ item.description }}</div>
      </div>
    </div>

    <div v-if="filteredTerms.length === 0" class="empty-state">
      검색 결과가 없습니다.
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import UtilMixin from "@/common/mixins/UtilMixin";
import glossaryData, { type GlossaryTerm } from "@/apt/assets/json/glossaryData";

export default defineComponent({
  name: "AptGlossaryView",
  mixins: [UtilMixin],
  data() {
    return {
      searchQuery: "",
      selectedCategory: "전체",
      glossary: glossaryData as GlossaryTerm[],
    };
  },
  computed: {
    categories(): string[] {
      const cats = [...new Set(this.glossary.map((g) => g.category))];
      return ["전체", ...cats];
    },
    filteredTerms(): GlossaryTerm[] {
      let result = this.glossary;

      if (this.selectedCategory !== "전체") {
        result = result.filter((g) => g.category === this.selectedCategory);
      }

      if (this.searchQuery.trim()) {
        const q = this.searchQuery.trim().toLowerCase();
        result = result.filter(
          (g) =>
            g.term.toLowerCase().includes(q) ||
            g.description.toLowerCase().includes(q)
        );
      }

      return result;
    },
  },
});
</script>
